<template>
    <nav class="navbar fixed-bottom survey-nav-buttons">

  <b-row class="pt-3 w-100">
    <b-col sm="2">
      <b-btn
        v-show="step > 1"
        variant="outline-primary"
        size="lg"
        class="w-120"
        @click="previousStep"
        >Previous</b-btn
      >
    </b-col>
    <b-col sm="8">
      <div v-if="ShowErrorMsg">             
        <font-awesome-icon icon="exclamation-triangle" class="fa-2x"/>   
        <span class="error-message">All fields are required!</span>
        </div>
    </b-col>
    <b-col sm="2">
      <b-btn
        v-show="step >= 1 && step < 8"
        variant="primary"
        size="lg"
        class="w-120"
        @click="moveNext"
        >Next</b-btn
      >
      <b-btn class="w-100" v-show="step > 7" variant="primary" size="lg" @click="moveNext"
        >Finish</b-btn
      >
    </b-col>
  </b-row>
  </nav>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add(fas)

export default {
  name: "surveyNav",
  components: {
    FontAwesomeIcon
  },
  props: ["step", "ShowErrorMsg"],
  methods: {
    moveNext() {
      this.$emit("move-next");
    },
    previousStep() {
      this.$emit("move-previous");
    }
  }
};
</script>
<style scoped>
.navbar{
  background-color: #ffffff;
}
.survey-nav-buttons{
  padding-bottom: 60px;
}
.fa-exclamation-triangle{
  color: red;
}
.error-message{
  color: red;
  font-size: 1.5em;
  padding-left: 10px;
}
</style>
